import styled from 'styled-components'
import breakpoints from 'utils/consts/breakpoints'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and ${breakpoints.device.tablet} {
    max-width: calc(100vw - 48px);
  }

  @media screen and ${breakpoints.device.mobile} {
    max-width: calc(100vw - 32px);
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 32px;

  @media screen and ${breakpoints.device.tablet}, ${breakpoints.device.mobile} {
    row-gap: 24px;
  }
`

export const Item = styled.div``

export const Paragraph = styled.p`
  font: var(--typography-14-20-normal);
  color: #121432;
  margin: 0;
`

export const Header = styled.h5`
  font: var(--typography-14-20-regular);
  color: #717284;
  margin: 0 0 8px;
`

export const EmptyInfo = styled.div`
  margin: 0 auto;
  padding: 16px 0;
  max-width: 362px;
  text-align: center;
  letter-spacing: 0.3px;
  font: var(--typography-14-16-regular);
  color: var(--color-sw-60);

  @media screen and ${breakpoints.device.tablet} {
    margin-top: 8px;
  }

  @media screen and ${breakpoints.device.mobile} {
    max-width: 290px;
    padding: 0;
  }
`
